import { render, staticRenderFns } from "./BoDashboard.vue?vue&type=template&id=390874ec"
import script from "./BoDashboard.vue?vue&type=script&lang=js"
export * from "./BoDashboard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports